import { z } from "zod";

const schema = z.object({
  VITE_API_URL: z.string().default("/api"),
  VITE_SENTRY_DSN: z.string().optional().or(z.literal("")),
  VITE_POSTHOG_KEY: z.string().optional().or(z.literal("")),
  VITE_POSTHOG_HOST: z.string().url().default("https://app.posthog.com"),
  VITE_SUPPORT_WHATSAPP_NUMBER: z.string().optional().or(z.literal("")),
  VITE_PUBLIC_APP_URL: z.string().optional().or(z.literal(""))
});

export const env = schema.parse(import.meta.env);
